/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/BasePanel" />
import * as React from "react";
import { css, VssComponent } from "VSS/Platform/Layout";
import { ContentSize } from "VSSUI/Callout";
import { TitleSize } from "VSSUI/Header";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { CustomPanel, PanelContent, PanelFooter, PanelHeader } from "VSSUI/Panel";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { IBasePanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanel.Props";

const componentClassName = "integrations-base-panel";
export class BasePanel extends VssComponent<IBasePanelProps> {
    public render() {
        const { className, title, children, onDismiss, loadingSpinnerMessage, size, showCloseButton } = this.props;
        return (
            <CustomPanel
                className={css(componentClassName, className)}
                size={size === undefined ? ContentSize.Large : size}
                onDismiss={onDismiss}
                blurDismiss={false}
                lightDismiss={false}
            >
                <PanelHeader
                    onDismiss={onDismiss}
                    titleProps={{ text: title, size: TitleSize.Large }}
                    description={this._renderDescription()}
                    showCloseButton={showCloseButton}
                    backButtonProps={this.props.backButtonProps}
                />
                {loadingSpinnerMessage && (
                    <div className="flex flex-grow justify-center flex-center">
                        <Spinner size={SpinnerSize.large} label={loadingSpinnerMessage} />
                    </div>
                )}
                {!loadingSpinnerMessage && (
                    <>
                        <PanelContent className="panel-content-container">
                            {this._renderErrorMessage()}
                            {this._renderWarningMessage()}
                            <div className="content">{children}</div>
                        </PanelContent>
                        <PanelFooter className="footer">{this._renderFooter()}</PanelFooter>
                    </>
                )}
            </CustomPanel>
        );
    }

    private _renderDescription = (): JSX.Element | undefined => {
        return this.props.onRenderHeaderContent && this.props.onRenderHeaderContent();
    };

    private _renderErrorMessage = (): JSX.Element | undefined => {
        const { errorMessage } = this.props;
        return errorMessage ? (
            <MessageBar className="error-message-bar" severity={MessageBarSeverity.Error} onDismiss={this.props.onDismissErrorMessage}>
                {errorMessage}
            </MessageBar>
        ) : (
            undefined
        );
    };

    private _renderWarningMessage = (): JSX.Element | undefined => {
        const { warningMessage } = this.props;
        return warningMessage ? (
            <MessageBar className="warning-message-bar" severity={MessageBarSeverity.Warning}>
                {warningMessage}
            </MessageBar>
        ) : (
            undefined
        );
    };

    private _renderFooter = (): JSX.Element | undefined => {
        return this.props.onRenderPanelFooter && this.props.onRenderPanelFooter();
    };
}
